import {
  SUBJECTIVE_HEADING_SPECS,
  splitSoapByHeadings,
} from './soap-heading-split.util';

/** 2–3 word visit-reason label for list cards (problem name, else chief complaint). */
export function visitReasonFromSoap(
  soap:
    | {
        subjective?: string;
        problems?: { name?: string }[];
      }
    | null
    | undefined
): string | null {
  for (const problem of soap?.problems ?? []) {
    const clipped = clipVisitReason(problem.name);
    if (clipped) {
      return clipped;
    }
  }
  const sections = splitSoapByHeadings(soap?.subjective, SUBJECTIVE_HEADING_SPECS);
  const cc = sections.find((s) => s.id === 'cc' || /chief/i.test(s.title))?.body ?? '';
  const fromCc = clipVisitReason(cc);
  if (fromCc) {
    return fromCc;
  }
  const hpi = sections.find((s) => s.id === 'hpi')?.body ?? '';
  return clipVisitReason(hpi);
}

export function clipVisitReason(text: string | null | undefined, maxWords = 3): string | null {
  const cleaned = (text ?? '').replace(/\s+/g, ' ').trim();
  if (!cleaned || /^(n\/a|unknown|problem)$/i.test(cleaned)) {
    return null;
  }
  const words = cleaned.split(' ').filter(Boolean).slice(0, maxWords);
  if (!words.length) {
    return null;
  }
  return words.join(' ').replace(/[.,;:]+$/g, '');
}
